import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["image", "headline", "link", "content", "arrow", "onCardClick", "label", "asCard"];
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// card-5.twig
import { Content, Headline, LazyImageAdapter } from '@miro-site/components_utils';
import { Arrow, Box, Button, Card, Centered, Container, Grid, GridColumn, Link, Section } from '@miro-site/core';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DEFAULT_COLUMNS = 3;
var IconWrapper = styled(Box).attrs({
  $styles: {
    width: 40,
    height: 40,
    right: 16,
    bottom: 16
  }
}).withConfig({
  displayName: "RelatedContent__IconWrapper",
  componentId: "sc-tnc18b-0"
})(["display:flex;align-items:center;justify-content:center;transition:background ", ";background:", ";border-radius:50%;position:absolute;"], function (_ref) {
  var theme = _ref.theme;
  return theme.animation.transitionDuration;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryBlue;
});
var StyledCard = styled(Card).withConfig({
  displayName: "RelatedContent__StyledCard",
  componentId: "sc-tnc18b-1"
})(["cursor:pointer;overflow:hidden;&:hover{", "{background:", ";}}"], IconWrapper, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primaryBlueHover;
});
export var Item = function Item(props) {
  var image = props.image,
      headline = props.headline,
      link = props.link,
      content = props.content,
      arrow = props.arrow,
      onCardClick = props.onCardClick,
      label = props.label,
      asCard = props.asCard,
      restProps = _objectWithoutProperties(props, _excluded);

  var theme = useTheme();
  var isAnchorLink = typeof link.href !== 'undefined' && link.href.indexOf('#') === 0;

  var _useState = useState(false),
      isFocused = _useState[0],
      setFocused = _useState[1];

  var linkRef = useRef(null);

  var handleItemClick = function handleItemClick(e) {
    var selection = document.getSelection();

    if (selection !== null && selection !== void 0 && selection.toString()) {
      return;
    }

    var isLinkOpenHandled = false;

    if (onCardClick) {
      isLinkOpenHandled = onCardClick(link.href);
    }

    if (!isLinkOpenHandled) {
      e.preventDefault();

      if (!isAnchorLink) {
        window.open(link.href, link.href.startsWith('https://miro.com/') ? '_self' : '_blank');
      } else {
        var section = document.getElementById(link.href);
        window.location.href = link.href;

        if (section) {
          section.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  };

  var getTextContent = function getTextContent() {
    var hasTextContent = (headline === null || headline === void 0 ? void 0 : headline.text) || (content === null || content === void 0 ? void 0 : content.html) || (label === null || label === void 0 ? void 0 : label.html);
    return hasTextContent ? /*#__PURE__*/_jsxs(Box, {
      $px: [20, 24],
      $pt: theme.spaces.lg,
      $pb: arrow ? 80 : 32,
      children: [(label === null || label === void 0 ? void 0 : label.html) && /*#__PURE__*/_jsx(Content, _objectSpread({
        color: "dark",
        size: "tiny",
        colorTransparency: 0.4,
        textProps: {
          $styles: {
            marginBottom: [12],
            letterSpacing: 0.5,
            fontWeight: 500
          }
        }
      }, label)), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, {
        text: /*#__PURE__*/_jsx(Link, {
          ref: linkRef,
          href: link.href,
          onClick: function onClick(e) {
            handleItemClick(e);
          },
          onFocus: function onFocus(e) {
            if (e.target === linkRef.current) {
              setFocused(true);
            }
          },
          onBlur: function onBlur() {
            return setFocused(false);
          },
          children: headline.text
        }),
        align: "left",
        size: "tiny",
        tag: "h3"
      }), (content === null || content === void 0 ? void 0 : content.html) && /*#__PURE__*/_jsx(Content, _objectSpread({
        color: "grey",
        textProps: {
          $styles: {
            marginTop: headline !== null && headline !== void 0 && headline.text ? [theme.spaces.sm, theme.spaces.md] : 0
          }
        }
      }, content))]
    }) : null;
  };

  var getContent = function getContent() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [image && /*#__PURE__*/_jsx(LazyImageAdapter, {
        assets: image
      }), getTextContent(), arrow && /*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(Arrow, {
          "aria-hidden": "true",
          direction: isAnchorLink ? 'bottom' : 'right',
          width: [13, 15],
          height: [10, 12]
        })
      })]
    });
  };

  if (asCard) {
    return /*#__PURE__*/_jsx(StyledCard, _objectSpread(_objectSpread({
      as: "article",
      $styles: {
        height: '100%',
        background: theme.colors.primaryWhite,
        position: 'relative'
      },
      onClick: function onClick(e) {
        var _linkRef$current;

        if (!((_linkRef$current = linkRef.current) !== null && _linkRef$current !== void 0 && _linkRef$current.contains(e.target))) {
          handleItemClick(e);
        }
      },
      $isFocused: isFocused,
      "data-testid": "related-content-card"
    }, restProps), {}, {
      children: getContent()
    }));
  }

  return getContent();
};
var StyledGrid = styled(Grid).withConfig({
  displayName: "RelatedContent__StyledGrid",
  componentId: "sc-tnc18b-2"
})(["", " + ", "{", "}", ""], GridColumn, GridColumn, function (_ref4) {
  var theme = _ref4.theme;
  return theme.normalizeStyles({
    marginTop: [16, null]
  });
}, function (_ref5) {
  var _ref5$columns = _ref5.columns,
      columns = _ref5$columns === void 0 ? DEFAULT_COLUMNS : _ref5$columns;
  return css(["", ":nth-child(n+", "){", "}"], GridColumn, columns + 1, function (_ref6) {
    var theme = _ref6.theme;
    return theme.normalizeStyles({
      marginTop: [null, 20]
    });
  });
});

var RelatedContent = function RelatedContent(_ref7) {
  var headline = _ref7.headline,
      _ref7$items = _ref7.items,
      initialItems = _ref7$items === void 0 ? [] : _ref7$items,
      arrow = _ref7.arrow,
      _ref7$asCard = _ref7.asCard,
      asCard = _ref7$asCard === void 0 ? true : _ref7$asCard,
      _ref7$grid = _ref7.grid,
      grid = _ref7$grid === void 0 ? {
    columns: DEFAULT_COLUMNS
  } : _ref7$grid,
      onCardClick = _ref7.onCardClick,
      className = _ref7.className,
      contentLoader = _ref7.contentLoader,
      _ref7$sectionProps = _ref7.sectionProps,
      sectionProps = _ref7$sectionProps === void 0 ? {} : _ref7$sectionProps;
  var theme = useTheme();

  var _useState2 = useState(false),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(initialItems),
      items = _useState3[0],
      setItems = _useState3[1];

  useEffect(function () {
    if (!contentLoader) {
      setItems(initialItems);
      return;
    }

    var loader = contentLoader.loader;

    if (isLoading) {
      loadContent();
    }

    function loadContent() {
      return _loadContent.apply(this, arguments);
    }

    function _loadContent() {
      _loadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loadedItems;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loader(items.length);

              case 2:
                loadedItems = _context.sent;
                setItems(function (prev) {
                  return [].concat(_toConsumableArray(prev), _toConsumableArray(loadedItems));
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadContent.apply(this, arguments);
    }
  }, [isLoading, initialItems, contentLoader]);

  var getHeadlineContent = function getHeadlineContent() {
    if (headline !== null && headline !== void 0 && headline.backgroundImage) {
      return /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
        size: headline.size || 'mid',
        tag: headline.tag || 'h2',
        align: headline.align || 'center',
        text: /*#__PURE__*/_jsxs(_Fragment, {
          children: [headline.text, /*#__PURE__*/_jsx(Box, {
            "aria-hidden": true,
            $styles: {
              maxWidth: theme.layout.defaultContainerWidth,
              marginLeft: 'auto',
              marginRight: 'auto',
              position: 'relative'
            },
            children: /*#__PURE__*/_jsx(Box, {
              $styles: {
                position: 'absolute',
                top: ["calc(".concat(theme.multipliers.small(206), " / -2)"), null],
                bottom: [null, '100%'],
                right: [0, 270],
                width: [206, 323],
                zIndex: -1
              },
              children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                assets: headline.backgroundImage
              })
            })
          })]
        })
      }));
    }

    return /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
      size: headline.size || 'mid',
      tag: headline.tag || 'h2',
      align: headline.align || 'center'
    }));
  };

  return /*#__PURE__*/_jsx(Section, _objectSpread(_objectSpread({
    "data-place": "Related Content",
    type: "large"
  }, sectionProps), {}, {
    className: className,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && getHeadlineContent(), (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/_jsx(Box, {
        $styles: headline && {
          marginTop: [theme.spaces.xl]
        },
        children: /*#__PURE__*/_jsx(StyledGrid, {
          columns: grid.columns,
          align: "stretch",
          children: items.map(function (item) {
            return /*#__PURE__*/_jsx(Item, _objectSpread({
              arrow: arrow,
              asCard: asCard,
              onCardClick: onCardClick
            }, item), JSON.stringify(item));
          })
        })
      }), contentLoader && items.length < contentLoader.total && /*#__PURE__*/_jsx(Centered, {
        $mt: theme.spaces.xl,
        children: /*#__PURE__*/_jsx(Button, {
          $buttonType: "primary",
          $size: "medium",
          isLoading: isLoading,
          onClick: function onClick() {
            return setLoading(!isLoading);
          },
          children: "Show More"
        })
      })]
    })
  }));
};

export default RelatedContent;